import { cn } from 'lib/utils';

/** One option of a native radio group drawn as a segmented control. */
export const segmentClass = (checked: boolean): string =>
  cn(
    'inline-flex min-h-[36px] cursor-pointer items-center rounded-[5px] px-3 text-[13px] focus-within:ring-2 focus-within:ring-ring',
    checked
      ? 'bg-background font-medium text-foreground shadow-sm dark:bg-zinc-800'
      : 'text-muted-foreground hover:text-foreground'
  );

export const SEGMENTED = 'inline-flex w-fit rounded-md border border-zinc-200 bg-zinc-100 p-0.5 dark:border-zinc-800 dark:bg-zinc-900';
